import { apex } from "@/tenants/apex/apex.js"
import { asia } from "@/tenants/asia/asia.js"
import { boc } from "@/tenants/boc/boc.js"
import { coverHealth } from "@/tenants/coverHealth/coverHealth.js"
import { cvhl_core } from "@/tenants/coverHealth/coverHealth.js"
import { coverHealth_ca_prod } from "@/tenants/coverHealth/coverHealth.js"
import { coverHealthDev } from "@/tenants/coverHealthDev/coverHealthDev.js"
import { coverLibrary } from "@/tenants/coverLibrary/coverLibrary.js"
import { dbs } from "@/tenants/dbs/dbs.js"
import { fiLife } from "@/tenants/fiLife/fiLife.js"
import { fubon } from "@/tenants/fubon/fubon.js"
import { insuredNomads } from "@/tenants/insuredNomads/insuredNomads.js"
import { aevitae } from "@/tenants/aevitae/aevitae.js"
import { asisken } from "@/tenants/asisken/asisken.js"
import { oldmutualkenya } from "@/tenants/oldmutualkenya/oldmutualkenya.js"
import { luma } from "@/tenants/luma/luma.js"
import { msig } from "@/tenants/msig/msig.js"
import { msigih } from "@/tenants/msigih/msigih.js"
import { tcb } from "@/tenants/tcb/tcb.js"
import { xn } from "@/tenants/xn/xn.js"
import { qbe } from "@/tenants/qbe/qbe.js"
import { exponential } from "@/tenants/exponential/exponential.js"
import { madera } from "@/tenants/madera/madera.js"
import { tokiomarine } from "@/tenants/tokiomarine/tokiomarine.js"
import { cpicLife } from "@/tenants/cpicLife/cpicLife.js"
import { pacifico } from "@/tenants/pacifico/pacifico.js"
import { seyna } from "@/tenants/seyna/seyna.js"
import { vertex } from "@/tenants/vertex/vertex.js"
import { platformLifeDemo } from "@/tenants/platformLifeDemo/platformLifeDemo.js"
import { xtrategize } from "@/tenants/xtrategize/xtrategize.js"
import { dlvn } from "@/tenants/dlvn/dlvn.js"
import { icbl } from "@/tenants/icbl/icbl.js"
import { icbl_uat } from "@/tenants/icbl_uat/icbl_uat.js"
import { axaTh } from "@/tenants/axaTh/axaTh.js"
import { aiaTh } from "@/tenants/aiaTh/aiaTh.js"
import { priveDemo } from "@/tenants/priveDemo/prive.js"
import { coverGoDemo } from "@/tenants/coverGoDemo/coverGoDemo.js"
import { aigInDemo } from "@/tenants/aigDemo/aigin.js"
import { avivaAsiaDemo } from "@/tenants/avivaAsiaDemo/aviva.js"
import { boclife } from "@/tenants/boclife/boclife.js"
import { bocl } from "@/tenants/bocl/bocl.js"
import { trinity } from "@/tenants/trinity/trinity.js"
import { tawuniya } from "@/tenants/tawuniya/tawuniya.js"
import { tahoe } from "@/tenants/tahoe/tahoe.js"
import { axaHkIbm } from "@/tenants/axaHkIbm/axaHkIbm.js"
import { omsa } from "@/tenants/omsa/omsa.js"
import { avivauk } from "@/tenants/avivauk/avivauk.js"
import { moneysmart } from "@/tenants/moneysmart/moneysmart.js"
import { liberty } from "@/tenants/liberty/liberty"
import { gogox } from "@/tenants/gogox/gogox"
import { yallacompare } from "@/tenants/yallacompare/yallacompare"
import { bupa } from "@/tenants/bupa/bupa"
import { wfp } from "@/tenants/wfp/wfp"
import { asiaeb } from "@/tenants/asiaeb/asiaeb"
import { baTenant_dev } from "@/tenants/baTenant/baTenant"
import { salesTenant_dev } from "@/tenants/salesTenant/baTenant"
import { coverHealthAsiaPreprod } from "./coverHealthAsiaPreprod/coverHealth"
import { coverHealthEuPreprod } from "./coverHealthEuPreprod/coverHealth"
import { walaa } from "@/tenants/walaa/walaa"
import { presales_c2_uat, presale_dev } from "@/tenants/presales/presales"
import { medgulf } from "@/tenants/medgulf/medgulf"
import { gms_dev, gms_qa, gms_uat, gms_sandbox, gms_migration, gms_training, gms_prod } from "@/tenants/gms/gms"
import { infra_dr } from "@/tenants/infra/infra"
import { xn_dev, xn_uat, xn_qa, xn_prod, xn_preprod } from "@/tenants/xn/xn"
import { medihelp_uat, medihelp_dev, medihelp_qa, medihelp} from "@/tenants/medihelp/medihelp"
import { medisky_dev, medisky_uat, medisky_qa, medisky_prod } from "@/tenants/medisky/medisky"
import { humania_dev, humania_qa, humania_uat } from "@/tenants/humania/humania"
import { santevet_dev, santevet_uat, santevet_qa } from "@/tenants/santevet/santevet"
import { serenity } from "@/tenants/serenity/serenity"
import { ktaxa } from "@/tenants/ktaxa/ktaxa"
import { mopoc_dev } from "@/tenants/mopoc/mopoc"
import { pentest_preprod } from "@/tenants/pentest/pentest"
import { pentest_blaze } from "@/tenants/pentestBlaze/pentestBlaze"
import { big_policies_dev } from "@/tenants/bigPolicies/bigPolicies"
import { chdr_dev, chdr_dr } from "@/tenants/chdr/chdr"
import { pbc_dev, pbc_uat } from "@/tenants/pbc/pbc"
import { presales } from "@/tenants/presales/presales"
import { prudential_dev, prudential_qa, prudential_uat } from "@/tenants/prudential/prudential.js"
import { atlas_gamma } from "@/tenants/atlas/atlas.js"
import { petmga_sandbox } from "@/tenants/petmga/petmga.js"
import { assa_gt_uat, assa_hn_uat, assa_dev, assa_qa } from "@/tenants/assa/assa.js"
import { forte_dev } from "@/tenants/forte/forte.js"
const urlHostToConfigsMap = {
	...avivauk,
	...bocl,
	...axaTh,
	...apex,
	...asia,
	...boc,
	...coverHealth,
	...coverHealthDev,
	...coverLibrary,
	...dbs,
	...fiLife,
	...fubon,
	...luma,
	...insuredNomads,
	...aevitae,
	...asisken,
	...oldmutualkenya,
	...msig,
	...msigih,
	...tcb,
	...xn,
	...qbe,
	...exponential,
	...madera,
	...tokiomarine,
	...cpicLife,
	...pacifico,
	...seyna,
	...vertex,
	...platformLifeDemo,
	...xtrategize,
	...dlvn,
	...icbl,
	...icbl_uat,
	...aiaTh,
	...priveDemo,
	...coverGoDemo,
	...aigInDemo,
	...avivaAsiaDemo,
	...boclife,
	...trinity,
	...tawuniya,
	...tahoe,
	...axaHkIbm,
	...omsa,
	...moneysmart,
	...liberty,
	...gogox,
	...yallacompare,
	...bupa,
	...wfp,
	...asiaeb,
	...baTenant_dev,
	...salesTenant_dev,
	...coverHealthAsiaPreprod,
	...coverHealthEuPreprod,
	...walaa,
	...presales_c2_uat,
	...medgulf,
	...gms_dev,
	...gms_uat,
	...gms_sandbox,
	...gms_migration,
	...gms_training,
	...gms_qa,
	...gms_prod,
	...xn_dev,
	...xn_uat,
	...xn_qa,
	...xn_preprod,
	...xn_prod,
	...mopoc_dev,
	...pentest_preprod,
	...pentest_blaze,
	...cvhl_core,
	...coverHealth_ca_prod,
	...medihelp_uat,
	...medihelp_dev,
	...medihelp_qa,
	...medihelp,
	...medisky_dev,
	...medisky_uat,
	...medisky_qa,
	...medisky_prod,
	...humania_dev,
	...humania_qa,
	...humania_uat,
	...infra_dr,
	...serenity,
	...ktaxa,
	...santevet_dev,
	...santevet_uat,
	...santevet_qa,
	...big_policies_dev,
	...chdr_dev,
	...chdr_dr,
	...pbc_dev,
	...pbc_uat,
	...presale_dev,
	...presales,
	...prudential_dev,
	...prudential_qa,
	...atlas_gamma,
	...petmga_sandbox,
	...assa_gt_uat,
	...assa_hn_uat,
	...assa_dev,
	...assa_qa,
	...forte_dev,
	...prudential_uat,
}

// Original mapping for localhost:3000 is in coverLibrary.js
// You can override here for more convenient local development under different tenant
// Uncomment and adjust next line
// urlHostToConfigsMap["localhost:3000"] = xn["xn-uat-admin.quote.hk"]

export { urlHostToConfigsMap }
